import { DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { BasePortalOutlet } from '@angular/cdk/portal';

import {Injector} from '@angular/core';

export class ApDialogConfig<D = unknown, TInitialState = Record<string, unknown>,
R = unknown, C extends BasePortalOutlet = BasePortalOutlet> extends DialogConfig<D, R, C> {
  // injector that can provide $scope for UpgradeComponents
  elementInjector?: Injector;

  // This property allows backwards compatibility with old modals.
  // Use 'data' property instead for anything new.
  initialState?: TInitialState;
}

export interface ApDialogRef<R = unknown, C = unknown> extends DialogRef<R, C> {
  readonly config: ApDialogConfig<any, any, DialogRef<R, C>, BasePortalOutlet>;
}
